import {
  IndexRouteContent,
  LayoutRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';
import { AppModules } from 'appContainer/types';
import { adminBoundary } from 'router/declarative/adminBoundary';
import { composeBoundaries } from 'router/declarative/composeBoundaries';
import { featureFlagBoundary } from 'router/declarative/featureFlagBoundary';
import { Features } from '@ardoq/features';

export const routes = {
  path: '/application-completeness',
  appModule: AppModules.APPLICATION_COMPLETENESS,
  content: composeBoundaries([
    featureFlagBoundary(
      [Features.VISIBILITY_TMP_APPLICATION_COMPLETENESS_PAGE],
      { pageName: 'Application Completeness' }
    ),
    adminBoundary(),
  ]),
  children: [
    {
      path: { layout: true },
      content: async (): LayoutRouteContent =>
        (await import('./ApplicationCompletenessLayout'))
          .ApplicationCompletenessLayout,
      children: [
        {
          path: { index: true },
          content: async (): IndexRouteContent =>
            (await import('./ApplicationCompletenessPage'))
              .ApplicationCompletenessPage,
        },
      ],
    },
  ],
} as const satisfies RouteNode;
